import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { useLayoutContext } from '../context/LayoutContext';

const NonAuthLayout = ({ children }) => {
  const { layoutState } = useLayoutContext();
  const { layoutModeType } = layoutState;

  useEffect(() => {
    document.body.setAttribute('data-bs-theme', layoutModeType);
    return () => document.body.removeAttribute('data-bs-theme');
  }, [layoutModeType]);

  return <div>{children}</div>;
};

NonAuthLayout.propTypes = {
  children: PropTypes.node,
};

export default NonAuthLayout;